import { AuthMessageCode } from 'app/api/auth/constant'
import R from 'app/assets/R'

export const MSG_CODE_TO_MESSAGE_KEY = {
  [AuthMessageCode.AUTH_WRONG_USERNAME_PASSWORD]:
    R.strings.wrong_username_or_password,
}
